import { faPlus } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import { ERouteStaticParams, Routes } from '../../classes/Routes';
import Alert from '../../components/UI/Alert/Alert';
import Button from '../../components/UI/Button/Button';
import Container from '../../components/UI/Container/Container';
import Spinner from '../../components/UI/Spinner/Spinner';
import Table from '../../components/UI/Table/Table';
import TableTh from '../../components/UI/Table/TableTh/TableTh';
import { useTableSort } from '../../components/UI/Table/useTableSort';
import { IAppState, IOrganizationState } from '../../interfaces';
import { linkHandler } from '../../shared/utility';
import * as actions from '../../store/actions';
import { ETranslation } from '../../translations/translation-keys';


interface IProps extends RouteComponentProps { }

const Operators: React.FC<IProps> = ({ history }) => {
  const dispatch = useDispatch();

  const { loading, error, organizations} = useSelector<IAppState, IOrganizationState>(state => state.organization);
  const { sort, onSort, items: sortedOrganizations } = useTableSort({ data: organizations });

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(actions.listOrganizations());
  }, [dispatch]);

  const showOperator = (event: React.MouseEvent<HTMLTableRowElement>, id: string) => {
    linkHandler(event, Routes.OPERATOR(id), history);
  }

  return (
    <Container>
      {error && <Alert children={error} />}
      <h2>{t(ETranslation.TITLE_OPERATORS)}</h2>
      <Button onClick={() => history.push(Routes.OPERATOR(ERouteStaticParams.new))} icon={faPlus} style={{ marginBottom: "1rem" }}>{t(ETranslation.OPERATORS_ADD_NEW)}</Button>
      {loading
        ? <Spinner />
        : organizations && sortedOrganizations
          ? (
            <Table hover sortContext={{ sort, onSort }}>
              <thead>
                <tr>
                  <TableTh sort="name">{t(ETranslation.OPERATOR_NAME)}</TableTh>
                  <TableTh sort="operatorToken">{t(ETranslation.COMMON_TOKEN)}</TableTh>
                  <TableTh sort="businessId">{t(ETranslation.OPERATOR_BUSINESS_ID)}</TableTh>
                  <TableTh sort="streetAddress">{t(ETranslation.COMMON_STREET_ADDRESS)}</TableTh>
                  <TableTh sort="zip">{t(ETranslation.COMMON_ZIP)}</TableTh>
                  <TableTh sort="city">{t(ETranslation.COMMON_CITY)}</TableTh>
                  <TableTh sort="countryCode">{t(ETranslation.COMMON_COUNTRY)}</TableTh>
                </tr>
              </thead>
              <tbody>
                {sortedOrganizations.map((organization) => (
                  <tr key={organization.id} onClick={(e) => showOperator(e, organization.id)}>
                    <td>{organization.name}</td>
                    <td>{organization.operatorToken}</td>
                    <td>{organization.businessId}</td>
                    <td>{organization.streetAddress}</td>
                    <td>{organization.zip}</td>
                    <td>{organization.city}</td>
                    <td>{organization.countryCode}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )
          : <p>{t(ETranslation.NO_OPERATORS)}</p>
      }
    </Container>
  );
}

export default Operators;
